import React, { useEffect, useState } from "react";
import { Card, Spinner, Row, Col } from "@themesberg/react-bootstrap";
import { fetchApi } from "../../../redux/api";
import { formatNumber } from "../../../redux/utils";
import moment from "moment";

const _bottom = { borderBottom: "1px solid #ccc" };

const Section = ({ description, amount, percentage }) => {
  const condition =
    description.includes("TOTAL RECURRENT REVENUE") ||
    description.includes("TOTAL BUDGET SIZE") ||
    description.includes("RECURRENT REVENUE") ||
    description.includes("TOTAL CAPITAL RECEIPT") ||
    description.includes("TOTAL RECURRENT EXPENDITURE");
  const styles = {
    fontWeight: condition ? "bold" : "",
    borderBottomWidth: 3,
    borderBottomStyle: "normal",
  };
  return (
    <Row className="mb-2">
      <Col md={6} style={{ ...styles, ..._bottom }}>
        {description}
      </Col>
      <Col md={4} style={{ textAlign: "end", ...styles, ..._bottom }}>
        {formatNumber(amount)}
      </Col>
      <Col md={2} style={{ textAlign: "end", ...styles, ..._bottom }}>
        {percentage}
        {percentage ? "%" : ""}
      </Col>
    </Row>
  );
};

const Section2 = ({ amount_2, amount, label = "INCREASE", percentage }) => {
  const styles = { fontWeight: "bold" };
  const thisYr = moment().format("YYYY");
  const nextYr = parseInt(thisYr) + 1;
  return (
    <Row className="mb-3">
      <Col md={3} className="m-0 p-0">
        <div style={{ ...styles, ..._bottom }}>{nextYr}</div>
        <div style={_bottom}>{formatNumber(amount)}</div>
      </Col>
      <Col md={3} className="m-0 p-0">
        <div style={{ ...styles, ..._bottom }}>{thisYr}</div>
        <div style={_bottom}>{formatNumber(amount_2)}</div>
      </Col>
      <Col md={4} className="m-0 p-0">
        <div style={{ textAlign: "end", ...styles, ..._bottom }}>{label}</div>
        <div
          style={{ textAlign: "end", ...styles, ..._bottom }}
        >
          {formatNumber(amount - amount_2)}
        </div>
      </Col>
      <Col md={2} className="m-0 p-0">
        <div></div>
        <div style={{ textAlign: "end", ...styles, ..._bottom }}>
          {percentage}
          {percentage ? "%" : "."}
        </div>
      </Col>
    </Row>
  );
};

export default function FullBudgetPerformance() {
  const thisYr = moment().format("YYYY");
  const nextYr = parseInt(thisYr) + 1;

  const [totalRev, setTotalRev] = useState([]);
  const [recCap, setRecCap] = useState([]);
  const [sectorial, setSectorial] = useState([]);
  const [budget, setBBudget] = useState([]);
  const [compare, setCompare] = useState([]);
  const [recRev, setRecRev] = useState([]);
  const [recRevCompare, setRecRevCompare] = useState([]);
  const [capRec, setcapRec] = useState([]);
  const [recExp, setRecExp] = useState([]);
  const [capCompare, setCapCompare] = useState([]);
  const [secAllocation, setSecAllocation] = useState([]);
  const [mdaRank, setMdaRank] = useState([]);
  const [capital, setCapital] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = (bType) => {
    return fetchApi(`budget_performance?b_type=${bType}`);
  };

  useEffect(() => {
    setLoading(true);
    Promise.all([
      getData("TOTAL RECURRENT REVENUE PERFORMANCE").then((d) => setTotalRev(d?.results || [])),
      getData("RECURRENT AND CAPITAL EXPENDITURE").then((d) => setRecCap(d?.results || [])),
      getData("SECTORIAL PERFORMANCE").then((d) => setSectorial(d?.results || [])),
      getData("BUDGET PROPOSAL").then((d) => setBBudget(d?.results || [])),
      getData("BUDGET COMPARISON").then((d) => setCompare(d?.results || [])),
      getData("RECURRENT REVENUE").then((d) => setRecRev(d?.results || [])),
      getData("RECURRENT REVENUE COMPARISON").then((d) => setRecRevCompare(d?.results || [])),
      getData("CAPITAL RECEIPT").then((d) => setcapRec(d?.results || [])),
      getData("RECURRENT EXPENDITURE").then((d) => setRecExp(d?.results || [])),
      getData("CAPITAL EXPENDITURE COMPARISON").then((d) => setCapCompare(d?.results || [])),
      getData("SECTORAL ALLOCATIONS").then((d) => setSecAllocation(d?.results || [])),
      getData("MDAs RANKING").then((d) => setMdaRank(d?.results || [])),
      getData("CAPITAL EXPENDITURE").then((d) => setCapital(d?.results || [])),
    ])
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, []);

  const _style = { fontWeight: "bold", marginTop: 20 };

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <h4>Budget Performance</h4>
        </div>
      </div>

      <Card border="light" className="shadow-sm">
        <Card.Body>
          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <div style={{ padding: "0 2rem" }}>
              <h5 className="text-center p-3" style={_style}>
                {thisYr} BUDGET PERFORMANCE
              </h5>

              {totalRev.map((item) => (
                <Section
                  key={item.id}
                  description={item.description}
                  amount={item.amount}
                  percentage={item.percentage}
                />
              ))}

              <h5 style={_style}>
                {thisYr} RECURRENT AND CAPITAL EXPENDITURE
              </h5>
              {recCap.map((item) => (
                <Section
                  key={item.id}
                  description={item.description}
                  amount={item.amount}
                  percentage={item.percentage}
                />
              ))}

              <h5 style={_style}>SECTORIAL PERFORMANCE {thisYr}</h5>
              {sectorial.map((item) => (
                <Section
                  key={item.id}
                  description={item.description}
                  amount={item.amount}
                  percentage={item.percentage}
                />
              ))}

              <h5 style={_style} className="text-center">
                HIGHLIGHT OF THE {nextYr} BUDGET PROPOSAL
              </h5>
              {budget.map((item) => (
                <Section
                  key={item.id}
                  description={item.description}
                  amount={item.amount}
                  percentage={item.percentage}
                />
              ))}

              <h5 style={_style}>
                COMPARISON BETWEEN THE {nextYr} AND {thisYr} BUDGET
              </h5>
              {compare.map((item) => (
                <Section2
                  key={item.id}
                  amount_2={item.amount_2}
                  amount={item.amount}
                  percentage={item.percentage}
                  label="DIFFERENCE"
                />
              ))}

              {recRev.map((item) => (
                <Section
                  key={item.id}
                  description={item.description}
                  amount={item.amount}
                  percentage={item.percentage}
                />
              ))}

              <h5 style={_style}>
                COMPARISON BETWEEN THE {nextYr} AND {thisYr} RECURRENT REVENUE
              </h5>
              {recRevCompare.map((item) => (
                <Section2
                  key={item.id}
                  amount_2={item.amount_2}
                  amount={item.amount}
                  percentage={item.percentage}
                />
              ))}

              {capRec.map((item) => (
                <Section
                  key={item.id}
                  description={item.description}
                  amount={item.amount}
                  percentage={item.percentage}
                />
              ))}

              <div style={{ marginTop: 20 }}>
                {recExp.map((item) => (
                  <Section
                    key={item.id}
                    description={item.description}
                    amount={item.amount}
                    percentage={item.percentage}
                  />
                ))}
              </div>

              <div style={_style}>
                {capital.map((item) => (
                  <Section
                    key={item.id}
                    description={item.description}
                    amount={item.amount}
                    percentage={item.percentage}
                  />
                ))}
              </div>

              <h5 style={_style}>
                COMPARISON BETWEEN THE {nextYr} AND {thisYr} CAPITAL EXPENDITURE
              </h5>
              {capCompare.map((item) => (
                <Section2
                  key={item.id}
                  amount_2={item.amount_2}
                  amount={item.amount}
                  percentage={item.percentage}
                />
              ))}

              <h5 style={_style}>
                TOTAL SECTORAL ALLOCATIONS IN FIGURES AND PERCENTAGES
              </h5>
              {secAllocation.map((item) => (
                <Section
                  key={item.id}
                  description={item.description}
                  amount={item.amount}
                  percentage={item.percentage}
                />
              ))}

              <h5 style={_style}>MDAs RANKING ALLOCATIONS</h5>
              {mdaRank.map((item) => (
                <Section
                  key={item.id}
                  description={item.description}
                  amount={item.amount}
                  percentage={item.percentage}
                />
              ))}
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
}
